// extracted by mini-css-extract-plugin
export var large = "Title-module--large--A8IlN";
export var lined = "Title-module--lined--jFtv6";
export var medium = "Title-module--medium--TEoLp";
export var small = "Title-module--small--jwX1k";
export var title = "Title-module--title--TqeUK";